import { useEffect, useState } from "react";
import { searchArchive } from "@/api/search";
import type { SearchIndexEntry } from "@/types";

const DEBOUNCE_MS = 280;
const SEARCH_LIMIT = 80;

export function useSearch() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<SearchIndexEntry[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [totalHint, setTotalHint] = useState<string | null>(null);

  useEffect(() => {
    const q = query.trim();
    if (q.length < 2) {
      setResults([]);
      setError(null);
      setTotalHint(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    const timer = setTimeout(() => {
      searchArchive(q, SEARCH_LIMIT)
        .then((hits) => {
          setResults(hits);
          setTotalHint(
            hits.length >= SEARCH_LIMIT
              ? `Показаны первые ${SEARCH_LIMIT} — уточните запрос`
              : `Найдено: ${hits.length}`
          );
          setError(null);
        })
        .catch((e) => {
          setResults([]);
          setTotalHint(null);
          setError(
            e instanceof Error
              ? e.message
              : "Поиск по архиву недоступен (проверьте /api/search)"
          );
        })
        .finally(() => setLoading(false));
    }, DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [query]);

  return {
    query,
    setQuery,
    results,
    loading,
    error,
    totalHint,
    ready: !loading,
  };
}
